import PlayerManager from "../../service/player-manager";
import SocketService from "../../service/socket";
import UIManager from "../../service/ui-manager";
import ToastService from "../../service/toast-service";
import AddSongFlow from "../../service/add-song-flow";

const isInRoom = () => {
  const roomState = SocketService.getState();
  const { isJoined: isInRoom } = roomState;
  return isInRoom;
};

const handlePlayPause = () => {
  const { isPlaying } = PlayerManager.getState();
  if (isPlaying) PlayerManager.pause();
  else PlayerManager.resume();
  if (isInRoom() && isPlaying) SocketService.pause();
  else SocketService.resume();
};

const handlePrev = () => {
  if (isInRoom()) SocketService.prev();
  PlayerManager.playPrev();
};

const handleNext = () => {
  if (isInRoom()) SocketService.next();
  PlayerManager.playNext();
};

const handleSeek = (seekTo) => {
  if (isInRoom()) SocketService.seek(seekTo);
  PlayerManager.seek(seekTo);
};

const handlePlayAt = async (idx) => {
  if (isInRoom()) SocketService.play(idx);
  PlayerManager.playAtIdx(idx);
};

const handleRemove = async (idx) => {
  if (isInRoom())
    return ToastService.errorToast(
      "Changes to queue can only be applied through room."
    );
  PlayerManager.deleteFromQueue(idx);
};

const handleVolume = (vol) => {
  PlayerManager.setVolume(typeof vol !== "number" ? 100 : Math.floor(vol));
};

const handleAddSongToQueue = () => {
  if (isInRoom())
    return ToastService.errorToast(
      "Changes to queue can only be applied through room."
    );
  AddSongFlow.initiate({ type: "queue" });
};

export {
  handlePlayPause,
  handlePrev,
  handleNext,
  handleSeek,
  handleVolume,
  handlePlayAt,
  handleRemove,
  handleAddSongToQueue,
};
